// extracted by mini-css-extract-plugin
export default {"event":"IroXxahSgAOQsi_WbhlK","jobfairColor":"w2Jd0tV7qAHhrONbtoHG"};